import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { GlobalContext } from '../../context/GlobalContext';
import logo from '../../logo.png'

function SideBar(props) {
    const { handlers } = useContext(GlobalContext);
    const { handleLogout } = handlers;

    return (
        <>
            <div className="h-screen hidden lg:block shadow-lg sticky top-0 w-80">
                <div className="bg-white h-full dark:bg-gray-700">
                    <Link to={'/'}>
                        <div className="flex items-center justify-start pt-6 ml-8">
                            <img
                                src={logo}
                                className="mr-3 h-6 sm:h-9"
                                alt="Logo"
                            />
                            <p className="font-bold dark:text-white text-xl">
                                S<span className='text-sky-500'>ee</span>kr
                            </p>
                        </div>
                    </Link>

                    <nav className="mt-6">
                        <div>
                            <Link to="/dashboard" className={`w-full dark:text-white flex items-center pl-6 p-2 my-2 transition-all duration-200 justify-start hover:text-slate-800 ${props.Home ? 'border-l-4 border-sky-500 text-slate-800' : 'text-gray-400'}`}>
                                <div className='flex gap-x-5'>
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" /></svg>

                                    <p>Home</p>
                                </div>
                            </Link>

                            <Link to="/dashboard/profile" className={`w-full dark:text-white flex items-center pl-6 p-2 my-2 transition-colors duration-200 justify-start hover:text-slate-800 ${props.Profile ? 'border-l-4 border-sky-500 text-slate-800' : 'text-gray-400'}`}>
                                <div className='flex gap-x-5'>
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" /></svg>

                                    <p>Profile</p>
                                </div>
                            </Link>

                            <Link to="/dashboard/job-vacancy-list/form" className={`w-full dark:text-white flex items-center pl-6 p-2 my-2 transition-colors duration-200 justify-start hover:text-slate-800 ${props.Post ? 'border-l-4 border-sky-500 text-slate-800' : 'text-gray-400'}`}>
                                <div className='flex gap-x-5'>
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" clipRule="evenodd" /></svg>

                                    <p>Post new job</p>
                                </div>
                            </Link>

                            <Link to={'/dashboard/job-vacancy-list'} className={`w-full flex items-center pl-6 p-2 my-2 transition-colors duration-200 justify-start hover:text-slate-800 ${props.JobList ? 'border-l-4 border-sky-500 text-slate-800' : 'text-gray-400'}`}>
                                <div className='flex gap-x-5'>
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" /><path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" /></svg>

                                    <p>Job list</p>
                                </div>
                            </Link>

                            <Link to="/dashboard/change-password" className={`w-full dark:text-white flex items-center pl-6 p-2 my-2 transition-colors duration-200 justify-start hover:text-slate-800 ${props.Password ? 'border-l-4 border-sky-500 text-slate-800' : 'text-gray-400'}`}>
                                <div className='flex gap-x-5'>
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clipRule="evenodd" /></svg>

                                    <p>Change Password</p>
                                </div>
                            </Link>

                            <button onClick={handleLogout} className={`w-full dark:text-white flex items-center pl-6 p-2 my-2 transition-colors duration-200 justify-start hover:text-slate-800 ${props.Logout ? 'border-l-4 border-sky-500 text-slate-800' : 'text-gray-400'}`}>
                                <div className='flex gap-x-5'>
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z" clipRule="evenodd" /></svg>

                                    <p>Log out</p>
                                </div>
                            </button>
                        </div>
                    </nav>
                </div>
            </div>
        </>
    );
}

export default SideBar;